import { Formik, ErrorMessage, Form } from "formik";
import { useState } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

const UpdateUserForm = ({ user, handleSubmit }) => {

    const [pinCodeError, setPinCodeError] = useState("");
    const userRoles = [
        {
            id: 1,
            role: 'ROLE_SUPER_ADMIN'
        },
        {
            id: 2,
            role: 'ROLE_MANAGER'
        },
        {
            id: 3,
            role: 'ROLE_CUSTOMER'
        },
        {
            id: 4,
            role: 'ROLE_SUPPORT_STAFF'
        }
    ];
    const fRole = userRoles.find(el=>el.role === user.roles[0]);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                name: user.name || '',
                mobile_number: user.mobile_number || '',
                email: user.email || '',
                address: user.address || '',
                address_line_2: user.address_line_2 || '',
                address_line_3: user.address_line_3 || '',
                city: user.city || '',
                state: user.state || '',
                country: user.country || '',
                pin_code: user.pin_code || '',
                role: fRole?.id
            }}
            validate={(values) => {
                const errors = {};

                if (!values.name) {
                    errors.name = "Name is required";
                }

                if (!values.mobile_number) {
                    errors.mobile_number = "Mobile number is required";
                }
                if (!values.role) {
                    errors.role = "Role is required";
                }

                if (!values.email) {
                    errors.email = "Email is required";
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                    errors.email = "Invalid email address";
                }
                if (values.pin_code) {
                    if (!/^[A-Z0-9 ]{5,8}$/i.test(values.pin_code)) {
                        errors.pin_code = 'Invalid UK postcode format';
                    }
                }

                return errors;
            }}
            onSubmit={handleSubmit}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                setFieldValue,
                setFieldTouched,
                handleSubmit,
                isSubmitting,
                setFieldError
            }) => {
                const fetchAddressDetails = async (pinCode) => {
                    if (pinCode.length >= 5) {
                        const postCode = pinCode.toUpperCase();
                        try {
                            const response = await fetch(`https://api.postcodes.io/postcodes/${postCode}`);
                            const data = await response.json();
                            if (data.status === 200 && data.result) {
                                setFieldValue('pin_code', postCode || '');
                                setFieldValue('city', data.result.admin_district || '');
                                setFieldValue('state', data.result.region || '');
                                setFieldValue('country', data.result.country === 'England' ? 'United Kingdom' : data.result.country);
                                setPinCodeError('');
                            } else {
                                setFieldValue('city', '');
                                setFieldValue('state', '');
                                setFieldValue('country', '');
                                setPinCodeError('Invalid postcode');
                            }
                        } catch (error) {
                            setFieldError('pin_code', 'Invalid postcode');
                            setPinCodeError('Something went wrong while verifying the postcode.');
                        }
                    } else {
                        setPinCodeError('');
                    }
                };

                return (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name"
                                    name="name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                <ErrorMessage className="help-error" name="name" component="div" />
                            </div>
                            <div className="col-md-6 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Email"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    disabled
                                />
                                <ErrorMessage className="help-error" name="email" component="div" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <PhoneInput
                                    country="GB"
                                    defaultCountry="GB"
                                    international
                                    placeholder="Enter phone number"
                                    value={values.mobile_number}
                                    onChange={(value) => setFieldValue('mobile_number', value)}
                                    onBlur={() => setFieldTouched('mobile_number', true)}
                                    className='form-control'
                                />
                                <ErrorMessage className="help-error" name="mobile_number" component="div" />
                            </div>
                            <div className="col-md-6 mb-3">
                                <select className="form-control" name="role" onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.role}>
                                    <option value={''}>---Select Role---</option>
                                    <option value={3}>Customer</option>
                                    <option value={4}>Support Staff</option>
                                    <option value={2}>Manager</option>
                                    <option value={1}>Supper Admin</option>
                                </select>
                                <ErrorMessage className="help-error" name="role" component="div" />
                            </div>
                        </div>


                      

                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="pin_code"
                                placeholder="Post Code"
                                onChange={(e) => {
                                    handleChange(e);
                                    setPinCodeError('');
                                }}
                                onBlur={(e) => {
                                    handleBlur(e);
                                    fetchAddressDetails(e.target.value);
                                }}
                                value={values.pin_code}
                            />
                            <ErrorMessage className="help-error" name="pin_code" component="div" />
                            {pinCodeError && <div className="help-error">{pinCodeError}</div>}
                        </div>

                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="address"
                                placeholder="Address Line 1"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address}
                            />
                        </div>

                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="address_line_2"
                                placeholder="Address Line 2"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address_line_2}
                            />
                        </div>
                         
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="city"
                                    placeholder="City"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.city}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="state"
                                    placeholder="State"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.state}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="country"
                                    placeholder="Country"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.country}
                                />
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            <button
                                type="submit"
                                className="t_primary_btn "
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Please wait..." : "Update Now"}
                            </button>
                        </div>

                    </form>
                );
            }}
        </Formik>
    );
};

export default UpdateUserForm;
